import React from 'react';
import { BrainPocketStore, exportStore } from '../../utils/BrainPocket/brainPocketStorage';

type TopBarProps = {
  store: BrainPocketStore;
  totals: {
    domains: number;
    articles: number;
    keyPoints: number;
    unread: number;
  };
  importBackup: (file: File) => Promise<void>;
  importError: string | null;
};

export default function TopBar({ store, totals, importBackup, importError }: TopBarProps) {
  return (
    <header className="brainpocket-topbar">
      <div className="brainpocket-title-group">
        <p className="brainpocket-eyebrow">Local-first knowledge tree</p>
        <h1>BrainPocket</h1>
        <div className="brainpocket-stats" aria-label="Library totals">
          <span>{totals.domains} domains</span>
          <span>{totals.articles} articles</span>
          <span>{totals.keyPoints} key points</span>
          <span>{totals.unread} unread</span>
        </div>
      </div>

      <div className="brainpocket-actions">
        <button
          type="button"
          onClick={() => exportStore(store)}
          className="brainpocket-button brainpocket-button-secondary"
        >
          Export Backup
        </button>
        <label className="brainpocket-button brainpocket-button-secondary">
          Import Backup
          <input
            type="file"
            accept=".json,application/json"
            className="brainpocket-file-input"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                void importBackup(file);
              }
              e.target.value = '';
            }}
          />
        </label>
      </div>
      {importError && <p className="brainpocket-import-error">{importError}</p>}
    </header>
  );
}
